module.exports = __webpack_public_path__ + "media/images/front/team_m-083a3105c5a6c133ac32921039115e19.jpg";